
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { BaseVue, CASign } from "@newview/base-web";
import { customModal } from "@newview/ui";
// import { CASign } from "@newview/tools";

@Component({
  name: "",
  components: { customModal },
})
export default class CASignVerify extends BaseVue {
  caSign = new CASign();
  showCASignVerifyInfo: boolean = false;
  sealType: number = 1; // 1：签字 2：签章
  caResult: any = {
    msg: "",
    sealSn: "",
    sealName: "",
    sealStart: "",
    sealExprie: "",
    signTime: "",
    isSuccess: false,
  };

  caPokeResult: any = {
    msg: "",
    isSuccess: false,
    authUnit: "",
    userName: "",
    sealName: "",
    certID: "",
    sealTime: "",
    sealSn: "",
    mac: "",
    ip: "",
  };

  mounted() {}

  /**
   * @description: 验章
   * @param {*} sealContent 签字内容
   * @param {*} sealResult 签字结果
   * @param {*} type  1:签字 2：签章
   * @return {*}
   * @author: pangting
   */
  async Verify(sealContent, sealResult, type) {
    debugger
    this.showLoading("正在验证中，该过程大概需要1-2分钟，请稍等...");
    try {
      this.sealType = type;
      let res: any = await this.caSign.VerifySealWithResult(
        sealContent,
        sealResult
      );

      if (type == 1) {
        this.caResult.msg = res.isSuccess ? "无错误" : res.msg;
        this.caResult.sealSn = res.verifydata.seal.sealSn;
        this.caResult.sealName = res.verifydata.seal.sealName;
        this.caResult.sealStart = res.verifydata.seal.sealStart;
        this.caResult.sealExprie = res.verifydata.seal.sealExprie;
        this.caResult.signTime = res.verifydata.signTime;
        this.caResult.isSuccess = res.isSuccess;
      } else {
        this.caPokeResult.msg = res.isSuccess ? "无错误" : res.msg;
        this.caPokeResult.isSuccess = res.isSuccess;
        this.caPokeResult.sealTime = res.verifydata.signTime;
        this.caPokeResult.mac = res.verifydata.mac;
        this.caPokeResult.ip = res.verifydata.ip;

        this.caResult.authUnit = res.verifydata.seal.authUnit;
        this.caResult.userName = res.verifydata.seal.userName;
        this.caResult.sealName = res.verifydata.seal.sealName;
        this.caResult.certID = res.verifydata.seal.certID;
        this.caResult.sealSn = res.verifydata.seal.sealSn;
      }

      this.closeLoading();
      this.showCASignVerifyInfo = true;
    } catch (error) {
      this.error("验证请求发送失败，请稍后重试");
      this.closeLoading();
    }
  }

  close() {
    this.showCASignVerifyInfo = false;
    this.$emit("close");
  }
}
